import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { PingPongBall, PingPongPaddlePaths } from "./PingPongPaddleMark";

/**
 * Club logo fallback — modern crest with a realistic ping-pong bat.
 */
export default function ClubPlaceholderIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 64 64">
      <circle cx="32" cy="32" r="30" opacity="0.12" />
      <circle
        cx="32"
        cy="32"
        r="30"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        opacity="0.22"
      />
      <PingPongPaddlePaths
        mode="mono"
        transform="translate(2 1) rotate(-16 28 32)"
      />
      <PingPongBall cx="49" cy="14.5" r="5.4" mode="mono" />
    </SvgIcon>
  );
}
